import React from 'react';
import { View, Text } from 'react-native';
import { useTranslation } from '@oolio-group/localization';
import { DocketStatus } from '@oolio-group/domain';
import DocketContinueStyles from './DocketItemContinue.styles';

export interface DocketItemBaseProps {
  text: string;
  subtext: string;
  status: DocketStatus;
}

const DocketItemHeader: React.FC<DocketItemBaseProps> = ({ text, subtext }) => {
  const { translate } = useTranslation();
  const styles = DocketContinueStyles();

  return (
    <View testID="docket-continue" style={styles.container}>
      <Text style={styles.text}>{translate(`kitchenDisplay.${text}`)}</Text>
      <Text style={styles.text}>{subtext}</Text>
    </View>
  );
};

export default React.memo(DocketItemHeader);
